/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserHasMonitoredObjectGroup
 */
export interface UserHasMonitoredObjectGroup {
    /**
     * 
     * @type {string}
     * @memberof UserHasMonitoredObjectGroup
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UserHasMonitoredObjectGroup
     */
    monitoredObjectGroup: number;
    /**
     * 
     * @type {number}
     * @memberof UserHasMonitoredObjectGroup
     */
    user: number;
}

export function UserHasMonitoredObjectGroupFromJSON(json: any): UserHasMonitoredObjectGroup {
    return UserHasMonitoredObjectGroupFromJSONTyped(json, false);
}

export function UserHasMonitoredObjectGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserHasMonitoredObjectGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'monitoredObjectGroup': json['monitored_object_group'],
        'user': json['user'],
    };
}

export function UserHasMonitoredObjectGroupToJSON(value?: UserHasMonitoredObjectGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'monitored_object_group': value.monitoredObjectGroup,
        'user': value.user,
    };
}


